import React, { useCallback } from "react";
import Icons from "../../../../Config/Images";
import "./EmptyWishlistPage.css";
import { useNavigate } from "react-router-dom";
const EmptyWishlistPage = () => {
  const navigate = useNavigate();

  //navigate to home route
  const handleButtonClick = useCallback(() => {
    navigate("/home");
  }, []);
  return (
    <>
      <div className="EmptyWishlistDiv">
        <div className="text-content">
          <h3>It feels so empty in here</h3>
          <p>Make a wish!</p>
        </div>
        <img src={Icons.emptyWishlistImage} alt="" />
        <div className="button-shopping">
          <button onClick={handleButtonClick}>Start Shopping</button>
        </div>
      </div>
    </>
  );
};

export default EmptyWishlistPage;
